import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Input, message, Row, Typography, Result } from "antd";
import { ACTION_TYPES } from "Store/models/auth";
import { FormItem } from "Components/form";
import React, { useEffect, useState } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { yupResolver } from "@hookform/resolvers";
import Yup from "ValidationModels/localizedYup";
import "Styles/app.less";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const STATUS = {
  INPUT: 0,
  SENT: 1,
};

const formValidation = Yup.object().shape({
  password: Yup.string().required(),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Şifreler eşleşmiyor"
  ),
});

export default function ResetPassword({ ...props }) {
  const [status, setStatus] = useState(STATUS.INPUT);

  let history = useHistory();

  const { resetPassword } = useStoreActions((store) => store.auth);
  const { process } = useStoreState((store) => store.auth);

  const { control, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(formValidation),
    mode: "onBlur",
  });

  const search = props.location.search;
  const params = new URLSearchParams(search);

  useEffect(() => {
    if (!params.get("tokenId") || !params.get("userId")) {
      history.push("/home");
    }
  }, []);

  useEffect(() => {
    if (process === ACTION_TYPES.RESET_PASSWORD) {
      setStatus(STATUS.SENT);
      setTimeout(() => {
        history.push("/login");
      }, 5000);
    }
  }, [process]);

  const Submit = async (form) => {
    const resetData = {
      token: params.get("tokenId"),
      userId: params.get("userId"),
      password: form.password,
    };
    resetPassword(resetData);

    /*   try {
      await API.post(
        "auth/users/" + params.get("userId") + "/confirmPasswordReset",
        { password: form.password },
        { params: { token: params.get("tokenId") } }
      ).then((response) => {
        setStatus(STATUS.SENT);
        setTimeout(() => {
          history.push("/login");
        }, 5000);
      });
    } catch (error) {
      message.error("Şifre yenileme işlemi sırasında bir hata meydana geldi.");
    } */
  };

  const passwordInputForm = (
    <div style={{ margin: 20 }}>
      <Col flex="1 1 100%" style={{ marginBottom: 8, textAlign: "center" }}>
        <Text style={{ fontSize: 18 }}>Şifre Sıfırlama</Text>
      </Col>
      <Col flex="1 1 100%" style={{ marginBottom: 32, textAlign: "center" }}>
        <Text>Yeni Şifrenizi Belirleyin</Text>
      </Col>
      <Col flex="1 1 100%">
        <form onSubmit={handleSubmit(Submit)}>
          <Col flex="1 1 100%">
            <FormItem error={errors.password}>
              <Controller
                name="password"
                control={control}
                as={
                  <Input.Password
                    prefix={
                      <FontAwesomeIcon icon={["fas", "lock"]} size="sm" />
                    }
                    placeholder="Yeni Şifre"
                  />
                }
              />
            </FormItem>
            <FormItem error={errors.passwordConfirmation}>
              <Controller
                name="passwordConfirmation"
                control={control}
                as={
                  <Input.Password
                    prefix={
                      <FontAwesomeIcon icon={["fas", "lock"]} size="sm" />
                    }
                    placeholder="Şifreyi Doğrula"
                  />
                }
              />
            </FormItem>

            <FormItem>
              <Button
                loading={process === ACTION_TYPES.RESETING_PASSWORD}
                block
                type="primary"
                htmlType="submit"
              >
                Kaydet
              </Button>
            </FormItem>
          </Col>
        </form>
      </Col>
    </div>
  );

  const renderContent = () => {
    switch (status) {
      case STATUS.INPUT:
        return passwordInputForm;
      case STATUS.SENT:
        return (
          <Col>
            <Result
              status="success"
              title="Şifrenizi güncellediniz"
              subTitle="Giriş ekranına yönlendiriliyorsunuz. Yeni şifreniz ile giriş
              yapabilirsiniz."
              extra={[<Link to="login">Giriş</Link>]}
            />
          </Col>
        );
    }
  };

  return (
    <div className={`forgot-password-form-wrapper`}>
      <Row className="forgot-password-form">{renderContent()}</Row>
    </div>
  );
}
